<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="goreturn"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 选择 -->
    <div class="flex mgt-30 mgb-50">
      <div
        :class="selectActive == v.id ? 'topselectActive' : 'topselect'"
        v-for="v in select"
        :key="v.id"
        @click="selectBtn(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 设备参数配置 -->
    <div class="pd-10 bg-white oneSet" v-if="selectActive == 1">
      <el-form ref="form" :model="form" label-width="130px">
        <div class="mgb-10 color052154 fw-600">广告灯开关时间</div>
        <el-form-item label="开启">
          <el-time-picker
            v-model="form.ggOpen"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            placeholder="请选择广告灯开启时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="关闭">
          <el-time-picker
            v-model="form.ggClose"
            placeholder="请选择广告灯关闭时间"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
        <div class="mgb-10 color052154 fw-600">取水灯开关时间</div>
        <el-form-item label="开启">
          <el-time-picker
            v-model="form.qsOpen"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            placeholder="请选择取水灯开启时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="关闭">
          <el-time-picker
            v-model="form.qsClose"
            placeholder="请选择取水灯关闭时间"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
        <div class="mgb-10 color052154 fw-600">伴热带启停温度</div>
        <el-form-item label="启动">
          <el-input v-model="form.brdStart" placeholder="请输入伴热带启动温度">
            <template slot="append">℃</template>
          </el-input>
        </el-form-item>
        <el-form-item label="停止">
          <el-input v-model="form.brdStop" placeholder="请输入伴热带停止温度">
            <template slot="append">℃</template>
          </el-input>
        </el-form-item>
        <div class="mgb-10 color052154 fw-600">加热灯启停温度</div>
        <el-form-item label="启动">
          <el-input v-model="form.jrdStart" placeholder="请输入加热灯启动温度">
            <template slot="append">℃</template>
          </el-input>
        </el-form-item>
        <el-form-item label="停止">
          <el-input v-model="form.jrdStop" placeholder="请输入加热灯停止温度">
            <template slot="append">℃</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ==== -->
    <!-- 充值套餐配置 -->
    <div class="pd-10 bg-white" v-if="selectActive == 2">
      <el-dialog
        title="添加套餐"
        :visible.sync="dialogVisible"
        width="40%"
        center
        :close-on-click-modal="false"
        top="30vh"
      >
        <el-form
          ref="topForm"
          :rules="topFormRules"
          :model="topForm"
          label-width="150px"
        >
          <!-- <el-form-item label="套餐类型">
            <el-radio-group @change="changeMenuType" v-model="topForm.menuType">
              <el-radio label="用户充值套餐"></el-radio>
              <el-radio label="活动充值套餐"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="用户充值套餐">
            <el-select
              multiple
              filterable
              v-model="topForm.menu"
              placeholder="请选择套餐"
            >
              <el-option
                v-for="(v, i) in menuAll"
                :key="i"
                :label="v.name + '--' + '充' + v.payPrice + '送' + v.givePrice"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="活动水卡套餐">
            <el-select
              multiple
              filterable
              v-model="topForm.active2Menu"
              placeholder="请选择套餐"
            >
              <el-option
                v-for="(v, i) in active2Menu"
                :key="i"
                :label="v.name + '--' + '充' + v.payPrice + '送' + v.givePrice"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="小程序活动水卡套餐">
            <el-select
              multiple
              filterable
              v-model="topForm.activeMenu"
              placeholder="请选择套餐"
            >
              <el-option
                v-for="(v, i) in activeMenu"
                :key="i"
                :label="v.name + '--' + '充' + v.payPrice + '送' + v.givePrice"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="合伙人充值套餐">
            <el-select
              multiple
              filterable
              v-model="topForm.partnerMenu"
              placeholder="请选择套餐"
            >
              <el-option
                v-for="(v, i) in partnerMenuArrNew"
                :key="i"
                :label="v.name + '--' + '充' + v.payPrice + '送' + v.givePrice"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="mgr-30" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="sureAddMenu('topForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-button type="primary" @click="addMenuBtn">添加套餐</el-button>
      <!-- 线上充值套餐 -->
      <div class="mgt-30 fw-600 mgb-5">用户水卡套餐</div>
      <div class="onMenu">
        <div
          class="one"
          v-for="(v, i) in onMenuArr"
          :key="i"
          @mouseenter="showOverlay(i)"
          @mouseleave="hideOverlay(i)"
        >
          <div class="f18">{{ v.packageName }}</div>
          <div class="f18 mgt-5">充 {{ v.payPrice }} 赠 {{ v.givePrice }}</div>
          <div class="overlay" v-show="isActive(i)">
            <el-button type="danger" class="delete-btn" @click="delMenuBtn(v)"
              >删除套餐</el-button
            >
          </div>
        </div>
      </div>

      <div class="mgt-30 fw-600 mgb-5">活动水卡套餐</div>
      <div class="onMenu">
        <div
          class="one"
          v-for="(v, i) in active2MenuArr"
          :key="i"
          @mouseenter="showOverlay2(i)"
          @mouseleave="hideOverlay2(i)"
        >
          <div class="f18">{{ v.packageName }}</div>
          <div class="f18 mgt-5">充 {{ v.payPrice }} 赠 {{ v.givePrice }}</div>
          <div class="overlay" v-show="isActive2(i)">
            <el-button type="danger" class="delete-btn" @click="delMenuBtn(v)"
              >删除套餐</el-button
            >
          </div>
        </div>
      </div>

      <!-- 活动充值套餐 -->
      <div class="mgt-30 fw-600 mgb-5">小程序活动水卡套餐</div>
      <div class="onMenu">
        <div
          class="one"
          v-for="(v, i) in activeMenuArr"
          :key="i"
          @mouseenter="showOverlay7(i)"
          @mouseleave="hideOverlay7(i)"
        >
          <div class="f18">{{ v.packageName }}</div>
          <div class="f18 mgt-5">充 {{ v.payPrice }} 赠 {{ v.givePrice }}</div>
          <div class="overlay" v-show="isActive7(i)">
            <el-button type="danger" class="delete-btn" @click="delMenuBtn(v)"
              >删除套餐</el-button
            >
          </div>
        </div>
      </div>

      <!-- 合伙人充值套餐 -->
      <div class="mgt-30 fw-600 mgb-5">合伙人充值套餐</div>
      <div class="onMenu">
        <div
          class="one"
          v-for="(v, i) in partnerMenuArr"
          :key="i"
          @mouseenter="showOverlay3(i)"
          @mouseleave="hideOverlay3(i)"
        >
          <div class="f18">{{ v.packageName }}</div>
          <div class="f18 mgt-5">充 {{ v.payPrice }} 赠 {{ v.givePrice }}</div>
          <div class="overlay" v-show="isActive3(i)">
            <el-button type="danger" class="delete-btn" @click="delMenuBtn(v)"
              >删除套餐</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- ======== -->

    <!-- 水卡充值 -->
    <div class="pd-10 bg-white oneSet" v-if="selectActive == 3">
      <!-- 充值结果弹框 -->

      <el-dialog
        title="充值结果"
        :visible.sync="topResultVisible"
        width="50%"
        center
        top="30vh"
        :close-on-click-modal="false"
      >
        <div class="tr">
          <el-button class="mgb-15 right" @click="getTopResult()"
            >刷新</el-button
          >
        </div>
        <el-table :data="topData" border style="width: 100%" max-height="250">
          <el-table-column
            type="index"
            :index="indexMethodNew"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="waterCard" label="卡号"> </el-table-column>
          <el-table-column prop="phone" label="手机号"> </el-table-column>
          <el-table-column prop="payPrice" label="支付金额"> </el-table-column>
          <el-table-column prop="givePrice" label="赠送金额"> </el-table-column>
          <el-table-column prop="orderPrice" label="实际到账">
          </el-table-column>
          <el-table-column prop="afterBalance" label="充值后水卡金额">
            <template slot-scope="scope">
              <span
                v-text="scope.row.afterBalance ? scope.row.afterBalance : '- -'"
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="充值结果">
            <template slot-scope="scope">
              <span
                v-text="
                  scope.row.state == 2
                    ? '未到账'
                    : scope.row.state == 3
                    ? '已到账'
                    : scope.row.state == 1
                    ? '待支付'
                    : '失败'
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="说明"> </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="topResultVisible = false"
            >已知晓</el-button
          >
        </span>
      </el-dialog>

      <el-form
        ref="activeForm"
        :rules="activeFormRules"
        :model="activeForm"
        label-width="120px"
      >
        <el-form-item label="活动赠送金额" prop="giveMoney">
          <el-input
            v-model="activeForm.giveMoney"
            placeholder="请输入赠送金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="实际到账">
          <el-input :disabled="true" v-model="activeForm.giveMoney"></el-input>
        </el-form-item>
        <el-form-item label="充值备注" prop="desc">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            v-model="activeForm.desc"
            placeholder="请输入充值备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <el-form
        :inline="true"
        ref="cardQueryForm"
        :model="cardQueryForm"
        label-width="80px"
      >
        <el-form-item label="水卡编号">
          <el-input
            v-model="cardQueryForm.num"
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getCard()">查询</el-button>
          <el-button
            @click="
              cardQueryForm = { num: '' };
              getCard();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        :data="cardTable"
        border
        stripe
        height="300"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod3"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="cardId" label="卡号"> </el-table-column>
        <el-table-column prop="status" label="是否绑定">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.status === 0
                  ? '未绑定'
                  : scope.row.status === 1
                  ? '已绑定'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="水卡状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.cardStatus === 0
                  ? '正常'
                  : scope.row.cardStatus === 1
                  ? '已挂失'
                  : scope.row.cardStatus === 2
                  ? '异常'
                  : '已失效'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间">
          <template slot-scope="scope">
            <span
              v-text="scope.row.createTime ? scope.row.createTime : '- -'"
            ></span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChangeCard"
        @current-change="handleCurrentChangeCard"
        :current-page="pageCard"
        :page-size="pageSizeCard"
        :page-sizes="[5, 20, 30, 40, 50]"
        layout=" prev, pager, next"
        :total="totalCard"
      >
      </el-pagination>
      <el-button type="primary" class="mgt-30" @click="cardTopBtn('activeForm')"
        >充值</el-button
      >
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";
export default {
  components: {
    breadcrumbs
  },
  data() {
    const giveMoney = (rule, value, callback) => {
      const reg = /^-?\d+(\.\d{1,2})?$/; // 检查正负整数或小数，最多两位小数
      const giveMoneyLimit = this.giveMoney; // 假设this.giveMoney已经在外部定义

      if (!value) {
        callback(new Error("请输入赠送金额"));
      } else {
        const numValue = parseFloat(value); // 将字符串转换为浮点数
        if (isNaN(numValue)) {
          callback(new Error("请输入有效的数字"));
        } else if (
          numValue > giveMoneyLimit ||
          numValue < -giveMoneyLimit ||
          !reg.test(value)
        ) {
          callback(
            new Error(
              `赠送金额在正负${giveMoneyLimit}之间，不能为0，最多能保留两位小数`
            )
          );
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      select: [
        { id: 1, name: "设备参数配置" },
        { id: 2, name: "充值套餐配置" },
        { id: 3, name: "水卡充值" }
      ],
      selectActive: 2,
      form: {
        ggOpen: "",
        ggClose: "",
        qsOpen: "",
        qsClose: "",
        brdStart: "",
        brdStop: "",
        jrdStart: "",
        jrdStop: ""
      }, //参数配置表单
      topForm: {
        menu: [],
        activeMenu: [],
        active2Menu: [],
        partnerMenu: []
      }, //套餐充值表单
      activeMenu: [],
      active2Menu: [],
      topFormRules: {
        menu: [{ required: true, message: "请选择套餐", trigger: "blur" }]
      },

      onMenuArr: [],
      activeIndexes: [], // 存放处于激活状态的item的索引
      activeIndexes7: [], // 存放处于激活状态的item的索引
      activeIndexes2: [], // 存放处于激活状态的item的索引
      activeIndexes3: [], // 存放处于激活状态的item的索引

      activeMenuArr: [],
      active2MenuArr: [],
      mergeMenuArr: [],
      totalMenu: [],
      partnerMenuArr: [],

      // 活动赠送充值
      activeForm: {
        giveMoney: "",
        desc: ""
      },
      activeFormRules: {
        giveMoney: [{ required: true, validator: giveMoney, trigger: "blur" }],
        // giveMoney: [
        //   { required: true, message: "请输入充值金额", trigger: "blur" },
        // ],

        desc: [{ required: true, message: "请输入充值备注", trigger: "blur" }]
      },
      cardTable: [],
      // 分页数据
      pageCard: 1, // 当前页，默认
      pageSizeCard: 10000, //每页显示多少条数据，默认
      totalCard: 50, // 数据总条数
      multipleSelection: [],
      // id
      zoneId: null,
      topResultVisible: false,
      topData: [],
      batchNum: null,
      menuAll: [],
      cardQueryForm: {
        num: ""
      },
      companyId: null,
      partnerMenuArrNew: [],
      giveMoney: null
    };
  },
  created() {
    this.zoneId = this.$route.query.zoneId;
    this.companyId = this.$route.query.companyId;

    this.getMenuZoneOn();
    this.getMenuZoneActive();
    this.getMenuZoneActive2();
    this.getMenuPartner(); //合伙人充值套餐
    this.getMergeMenu();
    this.getCard();
    this.getTopBigMoney();
  },
  methods: {
    // 充值的最大金额查询
    getTopBigMoney() {
      this.$api.zone.activeCha({ companyId: this.companyId }).then(res => {
        if (res.code === 200) {
          this.giveMoney = res.data.giveMoney;
        }
      });
    },

    changeMenuType(e) {
      this.topForm.menu = [];
      this.getMenuTotal();
      setTimeout(() => {
        this.menuAll = [];
        this.totalMenu.forEach(v => {
          if (e == "用户充值套餐" && v.cardType == 1) {
            this.menuAll.push(v);
          } else if (e == "活动充值套餐" && v.cardType == 2) {
            this.activeMenu.push(v);
          } else if (v.cardType == 3) {
            this.partnerMenuArrNew.push(v);
          }
        });
      }, 200);
    },
    delMenuBtn(v) {
      handleConfirm("确认删除该套餐吗?", "info")
        .then(() => {
          this.$api.zone.delMenu({ id: v.id }).then(res => {
            if (res.code === 200) {
              handleAlert("套餐已删除", "success");
              this.getMergeMenu();
              this.getMenuZoneOn();
              this.getMenuZoneActive();
              this.getMenuZoneActive2();
              this.getMenuPartner(); //合伙人充值套餐
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    showOverlay(index) {
      this.activeIndexes.push(index);
    },
    hideOverlay(index) {
      const idx = this.activeIndexes.indexOf(index);
      if (idx !== -1) {
        this.activeIndexes.splice(idx, 1);
      }
    },
    isActive(index) {
      return this.activeIndexes.includes(index);
    },

    showOverlay7(index) {
      this.activeIndexes7.push(index);
    },
    hideOverlay7(index) {
      const idx = this.activeIndexes7.indexOf(index);
      if (idx !== -1) {
        this.activeIndexes7.splice(idx, 1);
      }
    },
    isActive7(index) {
      return this.activeIndexes7.includes(index);
    },

    showOverlay2(index) {
      this.activeIndexes2.push(index);
    },
    hideOverlay2(index) {
      const idx = this.activeIndexes2.indexOf(index);
      if (idx !== -1) {
        this.activeIndexes2.splice(idx, 1);
      }
    },
    isActive2(index) {
      return this.activeIndexes2.includes(index);
    },

    showOverlay3(index) {
      this.activeIndexes3.push(index);
    },
    hideOverlay3(index) {
      const idx = this.activeIndexes3.indexOf(index);
      if (idx !== -1) {
        this.activeIndexes3.splice(idx, 1);
      }
    },
    isActive3(index) {
      return this.activeIndexes3.includes(index);
    },
    // getMenu
    // 添加套餐打开弹框按钮
    addMenuBtn() {
      this.getMenuTotal();
      this.getMenuTotal2();
      this.topForm = {
        menu: [],
        activeMenu: [],
        partnerMenu: [],
        active2Menu: []
      };
      setTimeout(() => {
        this.menuAll = [];
        this.activeMenu = [];
        this.partnerMenuArrNew = [];

        this.totalMenu.forEach(v => {
          if (v.cardType == 1) {
            this.menuAll.push(v);
          } else if (v.cardType == 7) {
            this.activeMenu.push(v);
          } else if (v.cardType == 2) {
            this.active2Menu.push(v);
          } else {
            this.partnerMenuArrNew.push(v);
          }
        });
      }, 200);
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.topForm.clearValidate();
      });
      this.dialogVisible = true;
      // this.menuAll = [];
      // setTimeout(() => {
      //   this.totalMenu.forEach((v) => {
      //     if (v.cardType == 1) {
      //       this.menuAll.push(v);
      //     }
      //   });
      // }, 200);
    },
    getMergeMenu() {
      this.$api.zone
        .menuList({ regionId: this.zoneId, cardType: null })
        .then(res => {
          if (res.code === 200) {
            this.mergeMenuArr = res.data;
            console.log(this.mergeMenuArr, "quanbu");
          }
        });
    },
    // 套餐列表-分区
    getMenuZoneOn() {
      this.$api.zone
        .menuList({ regionId: this.zoneId, cardType: 1 })
        .then(res => {
          console.log(res, "套餐列表");
          if (res.code === 200) {
            this.onMenuArr = res.data;
          }
        });
    },
    getMenuZoneActive() {
      this.$api.zone
        .menuList({ regionId: this.zoneId, cardType: 7 })
        .then(res => {
          console.log(res, "套餐列表2");
          if (res.code === 200) {
            this.activeMenuArr = res.data;
          }
        });
    },
    getMenuZoneActive2() {
      this.$api.zone
        .menuList({ regionId: this.zoneId, cardType: 2 })
        .then(res => {
          console.log(res, "套餐列表2");
          if (res.code === 200) {
            this.active2MenuArr = res.data;
          }
        });
    },
    getMenuPartner() {
      this.$api.zone
        .menuList({ regionId: this.zoneId, cardType: 3 })
        .then(res => {
          if (res.code === 200) {
            this.partnerMenuArr = res.data;
          }
        });
    },
    // 套餐列表-总
    getMenuTotal() {
      this.$api.marketing.topListPull({ type: 7 }).then(res => {
        console.log(res, "总");
        if (res.code === 200) {
          let menuArr = [];
          res.data.forEach(v => {
            // if (v.cardType === 1) {
            //   this.onMenuArr.push(v);
            // } else {
            //   this.activeMenuArr.push(v);
            // }
            menuArr.push(v);
          });
          this.totalMenu = menuArr.filter(obj1 => {
            const foundObj = this.mergeMenuArr.find(
              obj2 => obj2.packageId === obj1.id
            );
            return !foundObj;
          });
        }
      });
    },
    getMenuTotal2() {
      this.$api.marketing.topListPull({ type: 2 }).then(res => {
        console.log("type 2 活动套餐", res);
        if (res.code === 200) {
          let menuArr = [];
          res.data.forEach(v => {
            // if (v.cardType === 1) {
            //   this.onMenuArr.push(v);
            // } else {
            //   this.activeMenuArr.push(v);
            // }
            menuArr.push(v);
          });
          this.totalMenu = menuArr.filter(obj1 => {
            const foundObj = this.mergeMenuArr.find(
              obj2 => obj2.packageId === obj1.id
            );
            return !foundObj;
          });
        }
      });
    },
    // 确定新增套餐
    sureAddMenu(d) {
      if (
        this.topForm.menu.length == 0 &&
        this.topForm.activeMenu.length == 0 &&
        this.topForm.active2Menu.length == 0 &&
        this.topForm.partnerMenu.length == 0
      ) {
        this.dialogVisible = false;
        return;
      }
      this.$refs[d].validate(valid => {
        if (valid) {
          handleConfirm("确认新增套餐到分组内吗?", "info")
            .then(() => {
              this.$api.zone
                .addMenu({
                  packageId: [
                    ...this.topForm.menu,
                    ...this.topForm.activeMenu,
                    ...this.topForm.active2Menu,
                    ...this.topForm.partnerMenu
                  ],
                  regionId: this.zoneId
                })
                .then(res => {
                  if (res.code === 200) {
                    handleAlert("新增成功", "success");
                    this.dialogVisible = false;
                    this.getMergeMenu();
                    this.getMenuZoneOn();
                    this.getMenuZoneActive();
                    this.getMenuZoneActive2();
                    this.getMenuPartner(); //合伙人充值套餐
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 组内水卡表格
    getCard(pageNum) {
      if (!pageNum) {
        this.pageCard = 1;
      }
      this.$api.zone
        .cardTable({
          regionId: this.zoneId,
          pageNum: this.pageCard,
          pageSize: this.pageSizeCard,
          cardNum: this.cardQueryForm.num
        })
        .then(res => {
          if (res.code === 200) {
            this.cardTable = res.data.list;
            this.totalCard = res.data.total;
          }
        });
    },
    selectBtn(v) {
      this.selectActive = v.id;
    },

    cardTopBtn(d) {
      let that = this;
      this.$refs[d].validate(valid => {
        if (valid) {
          if (this.multipleSelection.length === 0) {
            handleAlert("请选择需要充值的水卡", "warning");
            return;
          }
          const noBind = [];
          let outTimeCard = [];
          this.multipleSelection.forEach(v => {
            if (v.status === 0) {
              noBind.push(v);
            }
            if (v.cardStatus !== 0) {
              outTimeCard.push(v);
            }
          });
          // if (noBind.length > 0) {
          //   handleAlert("存在未绑定的水卡,请重新选择", "warning");
          //   return;
          // }
          if (outTimeCard.length > 0) {
            handleAlert("存在非正常的水卡,请重新选择", "warning");
            return;
          }

          handleConfirm("确认充值吗?", "info")
            .then(() => {
              let arr = [];
              this.multipleSelection.forEach(v => {
                arr.push(v.cardId);
              });
              this.$api.zone
                .cardTop({
                  cardList: arr,
                  orderType: 3,
                  giveMoney: this.activeForm.giveMoney,
                  remark: this.activeForm.desc
                })
                .then(res => {
                  if (res.code === 200) {
                    // handleAlert("充值成功", "success");
                    that.batchNum = res.data.batch;

                    that.getTopResult(that.batchNum);
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 充值结果
    getTopResult(n = this.batchNum) {
      this.$api.zone.topList({ batch: n }).then(resNew => {
        if (resNew.code == 200) {
          this.topData = resNew.data;
          this.topResultVisible = true;
        }
      });
    },

    goreturn() {
      this.$router.push({
        path: "/zoneManage/zoneInfo",
        query: {
          zoneId: this.zoneId,
          companyId: this.companyId
        }
      });
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChangeCard(val) {
      this.pageSizeCard = val;
      this.getCard(this.pageCard);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChangeCard(val) {
      this.pageCard = val;
      this.getCard(this.pageCard);
    },
    //表格序号，根据索引+1
    indexMethod3(index) {
      return index + 1;
    },

    //表格序号，根据索引+1
    indexMethodNew(index) {
      return index + 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.onMenu {
  display: flex;
  flex-wrap: wrap;
  .one {
    margin-right: 15px;
    width: 200px;
    height: 100px;
    border: 1px solid var(--input-border);
    box-shadow: 2px 2px 2px 1px #ccc;
    position: relative;
    text-align: center;
    line-height: 50px;
    margin-top: 10px;
    cursor: pointer;
    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999;

      pointer-events: auto; /* 避免蒙层阻止鼠标事件传递给下方的内容 */
      opacity: 1;
      transition: opacity 0.3s ease;
    }
    .one:hover .overlay {
      pointer-events: auto; /* 鼠标悬停时使蒙层可接收鼠标事件 */
      opacity: 1;
    }

    .one:hover {
      box-shadow: none;
    }
    .delete-btn {
      // padding: 5px 10px;
      // background-color: red;
      // color: white;
      // border: none;
      // cursor: pointer;
    }
  }
}
.topselect {
  width: 200px;
  height: 30px;
  background: var(--card-bg);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  margin-right: 15px;
}
.topselectActive {
  width: 200px;
  height: 30px;
  background: var(--accent);
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  margin-right: 15px;
}

.oneSet {
  .el-input,
  .el-textarea {
    width: 300px !important;
  }
}
</style>
